import { useStore } from '@utils';
import { RoomsStore } from '../../../store';
import React, { FC } from 'react';

export const WhereOption: FC = (option: number) => {
  const roomsStore = useStore(RoomsStore);

  const { cabinetNumber, conferenceTitle } = roomsStore.getRoomByCabinetNumber(option);
  return <>{`${cabinetNumber} ${conferenceTitle}`}</>;
};
